import { render } from "./AdvanceDeductionsView.vue?vue&type=template&id=7c54d01a&scoped=true"
import script from "./AdvanceDeductionsView.vue?vue&type=script&lang=js"
export * from "./AdvanceDeductionsView.vue?vue&type=script&lang=js"

import "./AdvanceDeductionsView.vue?vue&type=style&index=0&id=7c54d01a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c54d01a"]])

export default __exports__